export default {
  // stats panel
  STATS_REFRESH: 'schedule-stats-panel:update',
  STATS_SUMMARY_REFRESH: 'stats-panel-summary:get-data',
  STATS_GRAPH_REFRESH: 'stats-panel-graphs:get-data',
  STATS_LEGENDS_REFRESH: 'stats-panel-legends:update',
  STATS_TOGGLE: 'schedule-stats-panel-toggle-button:toggle',
  STATS_UPDATE_ROSTER: 'schedule-stats-panel:update-roster',
  INSIGHTS_STATS_TOGGLE: 'schedule-stats-panel-toggle-button:insights-toggle',
  STATS_CONFIG: 'schedule-stats-config',

  // NEW STATS TABLE
  STATS_TABLE: 'schedule-stats-table:render',
  STATS_TABLE_VIEW: 'schedule-stats-table:update:view',
  DAYS_HEADER: 'schedule-days-header:render',
  STATS_TABLE_UPDATE: 'schedule-stats-table:update',
  STATS_TABLE_UPDATE_TIMEOFF_TOGGLE: 'schedule-stats-table:update-timeoff',
  STATS_PANEL_TOGGLE_GRAPH: 'schedule-stats-panel-toggle-graph',

  // BI
  BI_OPEN: 'schedule:business-insights:open',
  REQUIRED_STAFF_OPEN: 'schedule:required-staff:open',
  FETCH_LM_RULES: 'schedule:labor-model-rules:fetch',
  BI_SUMMARY_REFRESH: 'schedule:business-insights-summary:update',
  REFRESH_METRICS_CONFIG: 'schedule:business-insights:refresh-metrics-config',

  // roster
  ROSTER_START: 'schedule-roster:start',
  REFRESH: 'schedule-roster:refresh',
  UPDATE_EMPLOYEES: 'schedule-roster:update-employees',
  EMPLOYEE_UPDATED: 'schedule-roster:employee-updated',
  PUSHER_STACK_SHIFT: 'schedule-roster:stack-pusher',
  REFRESH_SHIFT: 'schedule-roster:refresh-shift',
  REFRESH_SHIFTS: 'schedule-roster:refresh-shifts',
  HARD_REFRESH: 'schedule-roster:hard-refresh',
  ADJUST_SHIFTS: 'schedule-roster:adjust-shifts',
  ROSTER_BULK_UPDATE_SUCCESS: 'schedule-roster:bulk-update-success',

  /**
   * To refresh roster with areas modified from onboarding
   * @event schedule-roster:refresh:onboarding-areas
   * @param {object}
   */
  REFRESH_ONBOARDING_AREAS: 'schedule-roster:refresh:onboarding-areas',
  SHIFT_OPEN: 'schedule-roster:shift:open',
  SHIFT_SAVE: 'schedule-roster:shift:save',
  SHIFT_REMOVE: 'schedule-roster:shift:remove',
  SHIFT_CANCEL: 'schedule-roster:shift:cancel',
  SHIFT_SAVE_REPEAT: 'schedule-roster:shift:save-repeat',
  SHIFT_REQUEST_APPROVE: 'schedule-roster:shift:request-approve',
  SHIFT_DECLINE: 'schedule-roster:shift:decline',
  EMPLOYEES_ADDED: 'schedule-roster:employees:added',
  EMPLOYEE_ADDED: 'schedule-roster:employee:added',
  EMPLOYEE_SELECTED: 'schedule:shift-form:select-employee',
  SHIFT_TIME_CHANGED: 'roster-edit:time-changed',
  COMPARE_ROSTER_AGREED_SHIFT: 'roster-edit:compare-roster-agreed-shift',
  TOGGLE_LOADER: 'schedule-roster:loader:toggle',
  PUBLISH_ROSTER: 'schedule-roster:publish-roster',
  SHIFT_EMPLOYEE_HIGHLIGHT: 'schedule-roster:highlight-employee-shift',
  ROSTER_LOADED: 'schedule-roster:loaded',
  DISMISS_EMPLOYEE_CARD_OPTION: 'schedule-roster:employee-card:option:dismiss',
  HIGHLIGHT_SHIFT: 'schedule-roster:highlight-shift',
  SHIFT_SELECT: 'schedule-roster:shift:select',
  EMPLOYEE_REMOVED_FROM_SHIFT: 'schedule-roster:employee:removed-from-shift',
  REMOVE_ALL_SHIFTS: 'schedule-roster:remove-all-shifts',
  DELETE_SELECTED_SHIFTS: 'schedule-roster:delete-selected-shifts',

  /**
   * Shift delete from schedule board for when add shift popover is on
   * @event schedule-roster:shift:delete
   */
  SHIFT_DELETE: 'schedule-roster:shift:delete',

  /**
   * Fires after GetRosterByIdsOrSwap returns with shift to swap
   * @event schedule-roster:shift:swap-approve
   * @param {object}
   */
  SHIFT_SWAP_APPROVE: 'schedule-roster:shift:swap-approve',

  /**
   * To show Shift form loading state
   * @event schedule:shift-form:closed
   * @param {object}
   */
  SHIFT_FORM_SHOW_LOADING: 'schedule:shift-form:show-loading',

  /**
   * To show Shift form loading state
   * @event schedule:shift-form:closed
   * @param {object}
   */
  SHIFT_FORM_HIDE_LOADING: 'schedule:shift-form:hide-loading',

  /**
   * Fires when shift modal opened which is the same with SHIFT_FORM_OPENED
   * but return objects instead
   * @todo Consolidate SHIFT_FORM_OPENED event with this
   * @event schedule:shift-form:opened:with-shift
   * @param {object}
   */
  SHIFT_FORM_OPENED_WITH_SHIFT: 'schedule:shift-form:opened:with-shift',

  /**
   * Fires when shift modal opened returns selected employee
   * @event schedule:shift-form:opened
   * @param {object} EmployeeObject
   */
  SHIFT_FORM_OPENED: 'schedule:shift-form:opened',

  /**
   * Fires when shift modal closed
   * @event schedule:shift-form:closed
   * @param {object}
   */
  SHIFT_FORM_CLOSED: 'schedule:shift-form:closed',

  /**
   * Fires when area changes in shift modal
   * @event schedule:shift-form:area-changed
   * @param {object}
   */
  SHIFT_FORM_AREA_CHANGED: 'schedule:shift-form:area-changed',

  /**
   * Fires when shift custom fields were changed
   * @event schedule:shift-form:custom-field:changed
   * @param {object}
   */
  SHIFT_CUSTOM_FIELD_CHANGED: 'schedule:shift-form:custom-field:changed',

  /**
   * Fires when shift custom fields were changed
   * @event schedule:shift-form:custom-field:changed
   * @param {object}
   */
  SHIFT_CUSTOM_FIELD_CATCH_ERROR:
    'schedule:shift-form:custom-field:catch-error',

  // TOPBAR VIEW SWITCHER
  CHANGE_SCHEDULE_VIEW: 'schedule:topbar:view-switcher:change-schedule-view',

  // KEYBOARD SHORTCUTS TOGGLE AREA / EMPLOYEE VIEWS
  CHANGE_VIEW_DAILY: 'schedule-roster:change-to-daily-view',
  CHANGE_VIEW_MONTH: 'schedule-roster:change-to-monthly-view',

  // KEYBOARD SHORTCUTS EMPLOYEE VIEW
  CHANGE_VIEW_WEEKLY_EMP: 'schedule-roster:change-to-weekly-emp-view',
  CHANGE_VIEW_FORTNIGHTLY_EMP: 'schedule-roster:change-to-fortnightly-emp-view',
  CHANGE_VIEW_FOURWEEKLY_EMP: 'schedule-roster:change-to-fourweekly-emp-view',

  // KEYBOARD SHORTCUTS EMPLOYEE VIEW AND AREA VIEW
  DISABLE_KEYBOARD_SHORTCUTS_EMP:
    'schedule-roster:disable-keyboard-shortcuts-emp-view',
  ENABLE_KEYBOARD_SHORTCUTS_EMP:
    'schedule-roster:enable-keyboard-shortcuts-emp-view',
  DISABLE_KEYBOARD_SHORTCUTS_AREA:
    'schedule-roster:disable-keyboard-shortcuts-area-view',
  ENABLE_KEYBOARD_SHORTCUTS_AREA:
    'schedule-roster:enable-keyboard-shortcuts-area-view',

  // KEYBOARD SHORTCUTS AREA VIEW
  CHANGE_VIEW_WEEKLY_AREA: 'schedule-roster:change-to-weekly-area-view',
  CHANGE_VIEW_FORTNIGHTLY_AREA:
    'schedule-roster:change-to-fortnightly-area-view',

  FOCUS_SELECTED_SHIFT: 'schedule-roster:focus-selected-shift',

  // Auto Build
  SHIFT_STRUCTURE: 'auto-build:shift-structure',
  FILL_EMPTY: 'auto-build:fill-empty',
  SMART_FORECAST: 'auto-build:smart-forecast',
  AUTO_RUN: 'auto-build:auto-run',
  BUILD_DRAFT_SCHEDULE: 'auto-build:build-draft-schedule',

  // Auto Fill
  AUTO_FILL_NOTIFICATION_SUCCESS: 'auto-fill:success',

  // Export
  PRINT_AREA_XLS: 'export:print-area-xls',
  PRINT_AREA_XLSX: 'export:print-area-xlsx',
  DOWNLOAD_AREA_JSON: 'export:download-area-json',
  PRINT_AREA: 'export:print-area',
  PRINT_EMPLOYEE_XLS: 'export:print-employee-xls',
  PRINT_EMPLOYEE_XLSX: 'export:print-employee-xlsx',
  DOWNLOAD_EMPLOYEE_JSON: 'export:download-employee-json',
  DOWNLOAD_EMPLOYEE_CSV: 'export:download-employee-csv',
  PRINT_EMPLOYEE: 'export:print-employee',
  SYNC_CALENDAR: 'export:sync-calendar',

  DATE_CHANGE: 'schedule-roster:date:change',
  UPDATE_DATE: 'schedule-roster:update:date',

  // locations
  // TODO: (move this to location module)
  LOCATIONS_AREA_SAVE: 'edit-area:save',
  LOCATIONS_AREA_REMOVE: 'edit-area:remove',

  // Sleepover
  LAUNCH_SLEEP_OVER_AREAS: 'sleepover-areas:open',
  SLEEP_OVER_AREA_RELOAD: 'sleep-over:areas-link:reload',
  SLEEP_OVER_SCHEDULE_RELOAD: 'sleep-over:schedule:reload',

  // Edit area modal
  LAUNCH_EDIT_AREA_MODAL: 'schedule-roster:edit-area-modal',
  LAUNCH_LOCATIONS_EDIT_AREA_MODAL: 'location-area-edit-modal',
  SHOW_ADVANCED_SETTINGS: 'edit-area:show-advanced-settings',

  // Shift history modal
  SHIFT_HISTORY_MODAL_OPEN: 'schedule-roster:shift-history-modal:open',
  SHIFT_HISTORY_MODAL_OPENED: 'schedule-roster:shift-history-modal:opened',
  SHIFT_HISTORY_MODAL_CLOSED: 'schedule-roster:shift-history-modal:closed',

  // Metrics
  METRICS_OPEN: 'schedule-metrics-dashboard:open',
  METRICS_CLOSE: 'schedule-metrics-dashboard:close',

  // Metrics settings
  DELETE_INTEGRATION_CONFIGURATION: 'delete-integration-configuration',
  CANCEL_DELETE_INTEGRATION_CONFIGURATION:
    'cancel-delete-integration-configuration',

  // copy shifts
  COPY_SAVE_TEMPLATE: 'copy-shifts:save-template',
  COPY_SHIFT: 'copy-shifts:copy-shift',
  COPY_SHIFT_MODAL: 'copy-shifts:copy-shift-modal',
  COPY_SHIFT_UNDO: 'copy-shifts:copy-shift-undo',
  PASTE_SHIFT: 'copy-shifts:paste-shift',
  CUT_SHIFT: 'copy-shifts:cut-shift',
  CHANGE_ROSTER_URL_DATE_LEGACY: 'schedule-roster:change-roster-date-legacy',
  CHANGE_SHIFT_TO_OPEN: 'schedule-roster:change-shift-to-open',
  MAKE_SHIFT_OPEN_V2: 'schedule-roster:make-shift-open-v2',
  DUPLICATE_SHIFT_V2: 'schedule-roster:duplicate-shift-v2',
  UNASSIGN_SHIFT: 'schedule-roster:unassign-shift',
  UNASSIGN_SHIFT_V2: 'schedule-roster:unassign-shift-v2',
  COPY_SHIFT_NOTIFY: 'copy-shifts:notify:copied',
  CUT_SHIFT_NOTIFY: 'copy-shifts:notify:cut',

  // options
  EXPAND_ALL_AREAS: 'option:expand-all-areas',
  COLLAPSE_ALL_AREAS: 'option:collapse-all-areas',

  // shortcuts
  CREATE_SHIFT_THRU_SHORTCUT: 'schedule-roster:create-shift-through-shortcut',

  // legacy views
  SHOW_ROSTER_VIEW_LEGACY: 'schedule-roster:view-shift-legacy',
  LOCATION_DROPDOWN_FILTER_BY_AREA_LEGACY: 'schedule-roster:filter-area:legacy',
  LOCATION_DROPDOWN_SEARCH: 'schedule-roster:location-dropdown:search',

  // agreed hours
  AUTO_SCHEDULE_AGREED_DAYS_TIMES: 'agreed-days-times:auto-schedule',

  // location selector events
  LOCATION_DROPDOWN_ON_DESELECT:
    'schedule-roster:location-dropdown:on-deselect',
  LOCATION_DROPDOWN_ON_SEARCH: 'schedule-roster:location-dropdown:on-search',
  LOCATION_DROPDOWN_ON_MODE_TOGGLE:
    'schedule-roster:location-dropdown:on-mode-toggle',
  LOCATION_DROPDOWN_ON_QUICK_SELECTION:
    'schedule-roster:location-dropdown:on-quick-selection',
  LOCATION_DROPDOWN_ON_MULTI_SELECTION:
    'schedule-roster:location-dropdown:on-multi-selection',

  ENTER: 'schedule-roster:enter',

  /**
   * Fires when showing shift approval modal
   * @event schedule-roster:bids:show
   * @param {object}
   */
  SHOW_SHIFT_APPROVALS: 'schedule-roster:approvals:show',

  /**
   * Fires when shift bids/requests need to be refreshed
   * @event schedule-roster:shift-bids:refresh
   * @param {object} { shiftId: number }
   */
  REFRESH_SHIFT_BIDS: 'schedule-roster:shift-bids:refresh',

  /**
   * Fires to show employee modal thru Schedule Tab
   * @event schedule-roster:employee:show
   * @param {object}
   */
  SHOW_EMPLOYEE_MODAL: 'schedule-roster:employee:show',

  /**
   * Fires to show add shift modal thru Schedule Tab
   * @event schedule-roster:add-shift-modal:show
   * @param {object}
   */
  SHOW_ADD_SHIFT_MODAL: 'schedule-roster:add-shift-modal:show',

  // Link shifts
  LINK_SHIFTS: 'schedule-roster:link-shifts:link-shifts',

  // Hours by area
  HOURS_BY_AREA_REFRESH: 'schedule-roster:hours-by-area:refresh',

  // Open shifts refresh
  REFRESH_OPEN_SHIFTS: 'schedule-roster:refresh-open-shifts',

  // XERO ONBOARDING EVENTS
  XERO_ONBOARDING_SCHEDULE_PUBLISH_PERFORMED:
    'onboarding:schedule:publish:performed',
  XERO_ONBOARDING_SCHEDULE_SHIFT_CREATE_PERFORMED:
    'onboarding:schedule:shift:create:performed',

  // SHIFT DETAILS POPOVER EVENTS
  SHIFT_DETAILS_POPOVER_UPDATED_SHIFTS:
    'schedule:shift-details-popover:updated-shifts',
  ROSTER_VISIBLE: 'schedule-roster:visible',
  ROSTER_IS_SCROLLING: 'schedule-roster:is-scrolling',
};
